module.exports = "/_next/static/images/b910f3ac3ae3aaa4e4711fa6a35e3a4e-rewards-hosting@2x.png";